export function getActiveBreakpointNumber() {
    const breakpointString = getComputedStyle(document.documentElement).getPropertyValue("--breakpoint");
    return parseInt(breakpointString, 10);
}

export function highlightSearchTerms(searchData) {
	const { terms, yearRange } = getSearchTerms();
    if (terms.length > 0 || yearRange) {
        highlightText(document.body, terms, yearRange);
    }
}

const getSearchTerms = () => {
    const searchTerms = {};
    let hasTerms = false;

    if (searchData.hasOwnProperty("terms")) {
        searchTerms.terms = searchData.terms;
        hasTerms = true;
    }

    if (searchData.hasOwnProperty("years")) {

        const years = searchData.years.split("-");

        switch (years.length) {
            case 1:
                // Single years are processed as a regular search terms
                if (hasTerms) {
                    searchTerms.terms.push(years[0]);
                } else {
                    searchTerms.terms = years;
                }
                break;

            case 2:
                // Matched years are tested to determine whether they fall within the range
                searchTerms.yearRange = years;
                break;

            default:
                console.warn(`searchHighlighter consumes a either a single year, or two years representing a range. Encountered ${years.length} years`);
        }
    }
    return searchTerms;
}

const highlightText = (node, terms, yearRange) => {
    if (!terms.length && !yearRange) return;

    const termRegex = terms.length
        ? new RegExp(`(${terms.map(term => term.replace(/[-/\\^$*+?.()|[\]{}]/g, '\\$&')).join("|")})`, "gi")
        : null;

    const yearRegex = /\b\d{4}\b/g;

    function wrapMatches(node) {
        // Skip processing for noscript, style, script, and img elements and their children
        if (node.nodeType === 3 && node.parentNode && node.parentNode.closest("noscript, style, script, img")) {
            return;
        }

        if (node.nodeType === 3) { // Only process text nodes
            let replacedText = node.nodeValue;

            if (termRegex) {
                replacedText = replacedText.replace(termRegex, `<span class="highlight">$1</span>`);
            }

            if (yearRange) {
                replacedText = replacedText.replace(yearRegex, (match) => {
                    const year = parseInt(match, 10);
                    return (year >= yearRange[0] && year <= yearRange[1])
                        ? `<span class="highlight highlight--year">${match}</span>`
                        : match;
                });
            }

            if (replacedText !== node.nodeValue) {
                const span = document.createElement("span");
                span.innerHTML = replacedText;
                node.replaceWith(span);
            }
        } else {
            node.childNodes.forEach(wrapMatches);
        }
    }
    wrapMatches(node);
}
